/* src/constants/stripeConstants.js */

// Read Price IDs from environment variables
// These are used by the FRONTEND for validation and selection logic.
// Ensure these variables are set in your .env (for local/test) and .env.production (for live)
const monthlyPriceId = process.env.REACT_APP_STRIPE_PRICE_ID_MONTHLY;
const yearlyPriceId = process.env.REACT_APP_STRIPE_PRICE_ID_YEARLY;

// Basic check to ensure the environment variables are loaded
if (!monthlyPriceId || !yearlyPriceId) {
    console.error(
        "Stripe Price ID environment variables (REACT_APP_STRIPE_PRICE_ID_MONTHLY, REACT_APP_STRIPE_PRICE_ID_YEARLY) are not set! " +
        "Check your .env files and build process."
        // Consider throwing an error or providing fallback TEST IDs for safety,
        // but ideally, the build should fail if these are missing for production.
    );
    // Example fallback (use with caution):
    // monthlyPriceId = 'YOUR_FALLBACK_TEST_MONTHLY_ID';
    // yearlyPriceId = 'YOUR_FALLBACK_TEST_YEARLY_ID';
}


export const PRICE_IDS = {
    monthly: monthlyPriceId,
    yearly: yearlyPriceId,
};

// Log which IDs are being used by the frontend (useful for debugging)
console.log("[stripeConstants] Frontend using Price IDs:", PRICE_IDS);

// Publishable key is handled separately, usually where Stripe.js is initialized
// export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;